<template>
  <div class="ms-radio">
    <p>{{ propsFilter.label }}</p>
    <el-radio-group
      v-model="valueRadio">
      <el-radio
        v-for="(radio, index) in propsFilter.options"
        :key="index"
        :label="radio.value">{{ radio.label }}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: 'MsRadioButton',
  props: {
    propsFilter: {
      type: Object,
      default () {
        return {}
      },
      required: true
    },
    propertyFilter: {
      type: String,
      default: null
    },
    typeFilter: {
      type: String,
      default: null
    }
  },
  computed: {
    valueRadio: {
      get () {
        let _query = this.$route.query
        let statusRadio = null
        if (_query[this.propertyFilter] !== undefined) {
          if (this.typeFilter === 'boolean') {
            if (_query[this.propertyFilter] === 'true') {
              statusRadio = true
            } else if (_query[this.propertyFilter] === 'false') {
              statusRadio = false
            } else {
              statusRadio = _query[this.propertyFilter]
            }
          } else {
            statusRadio = _query[this.propertyFilter]
          }
        } else {
          statusRadio = null
        }
        return statusRadio
      },
      set (value) {
        this.$emit('getFilterValue', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_shared/catalogForm/ms-radio-button.vue